import { makeStyles } from '@material-ui/core';

const useErrorMsgGeneralStyles = makeStyles((theme) => {
  return ({
    wrapper: {
      marginTop: theme.spacing(8),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    supportEmailText: {
      color: 'var(--teal-blue)',
    },
    tryAgainBtn: {
      border: '2px solid #007DB8',
      borderRadius: '4px',
      fontWeight: 500,
      fontSize: '14px',
      width: '93px',
      height: '38px',
      lineHeight: '20px',
      fontFamily: 'var(--font-family-bold)',
      textTransform: 'uppercase',
      textAlign: 'center',
      color: 'var(--white)',
      backgroundColor: 'var(--teal-blue)',
      '&:hover': {
        color: 'var(--white)',
        backgroundColor: 'var(--teal-blue)',
      }
    }
  });
});

export default useErrorMsgGeneralStyles;

